module.exports = __webpack_public_path__ + "img/logo.8046d704.png";